import { Component, Input, OnInit } from '@angular/core';
import { ScrEnvironment } from 'src/environments/environment';

@Component({
  selector: 'app-help-link-icon',
  templateUrl: './help-link-icon.component.html',
  styleUrls: ['./help-link-icon.component.scss']
})
export class HelpLinkIconComponent implements OnInit {

  constructor(private environment: ScrEnvironment) { }

  @Input() helpPath!: string;
  @Input() customClass!: string;
  helpPaths: Record<string,string> = {
    'Login': `${this.environment.helpbase}/help/prelogin/Pre-auth_Help/Login_to_SCR.htm`,
    'CreateAccount': `${this.environment.helpbase}/help/prelogin/Pre-auth_Help/Create_an_Account.htm`,
    'AccountCreationVerification': `${this.environment.helpbase}`,
    'ForgotPassword': `${this.environment.helpbase}/help/prelogin/Pre-auth_Help/Forgot_Password.htm`,
    'SetNewPassword': `${this.environment.helpbase}`,
    'ForgotUserID': `${this.environment.helpbase}/help/prelogin/Pre-auth_Help/Forgot%C2%A0User_ID.htm`,
    'RetrieveUserID': `${this.environment.helpbase}`,
  };
  ngOnInit(): void {
    this.helpPath = this.helpPaths[this.helpPath] ? this.helpPaths[this.helpPath] : `${this.environment.helpbase}/help/prelogin/index.htm`;
  }

}
